import React, { useState } from 'react'
import Carts from '../add-request/Carts'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';

function DetailsRequest() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    const fakData = {
        requester: {
            value: 1,
            label: 'Requester 1'
        },
        request_date: '2024-02-13',
        needed_on: '2024-02-27',
        Warehouse: {
            value: 1,
            label: 'Warehouse 1'
        },
        received_by: {
            value: 1,
            label: 'person 1'
        },
        phone_number: 933289353,
        company_project: {
            value: 1,
            label: 'Company 1'
        },
        status: {
            value: 1,
            label: 'Status 1'
        },
        request_number: 1235,
        ship_to: "test",
        location: "test",
        notes: 'notes notes',
        items: [
            {
                id: 2,
                name: "Camera 2",
                brand: "XXX",
                model: "yyy",
                category: "Category 2",
                sub_category: "Sub Category 2",
                warehouse: "Warehouse 2",
                Type: "Type 2",
                description: "description descrip desc description descrip desc",
                url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
                qty: 15,
                supplier: "Fadi Ayyas",
                newQty: 3
            },
            {
                id: 3,
                name: "Camera 3",
                brand: "XXX",
                model: "yyy",
                category: "Category 3",
                sub_category: "Sub Category 3",
                warehouse: "Warehouse 3",
                Type: "Type 3",
                description: "description descrip desc description descrip desc",
                url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
                qty: "15",
                supplier: "Fadi Ayyas",
                newQty: 1
            },
        ]
    }
    const [cartArr, setCartArr] = useState(fakData?.items)
    return (
        <>
            <main>
                <div className='div_table margin_main shadow_main' >
                    <div className='AddScriptsArchive' dir={langLocal === 'ar'? "rtl" : "ltr"} >
                        <h3>{translate('details_of_request')}</h3>
                        <div className='row_details' >
                            <div>
                                <span className='title' >{translate('requester')}</span>
                                <span>Requester 1</span>
                            </div>
                            <div>
                                <span className='title' >{translate('request_date')}</span>
                                <span>2024-02-13</span>
                            </div>
                            <div>
                                <span className='title' >{translate('needed_on')}</span>
                                <span>2024-02-13</span>
                            </div>
                            <div>
                                <span className='title' >{translate('warehouse')}</span>
                                <span>2024-02-13</span>
                            </div>
                            <div>
                                <span className='title' >{translate('received_by')}</span>
                                <span>person 1</span>
                            </div>
                            <div>
                                <span className='title' >{translate('phone_number')}</span>
                                <span>0933289353</span>
                            </div>
                            <div>
                                <span className='title' >{translate('company_project')}</span>
                                <span>Project 1</span>
                            </div>
                            <div>
                                <span className='title' >{translate('status')}</span>
                                <span>Pending</span>
                            </div>
                            <div>
                                <span className='title' >{translate('request_number')}</span>
                                <span>1234</span>
                            </div>
                            <div>
                                <span className='title' >{translate('ship_to')}</span>
                                <span>test</span>
                            </div>
                            <div>
                                <span className='title' >{translate('location')}</span>
                                <span>test</span>
                            </div>
                            <div>
                                <span className='title' >{translate('notes')}</span>
                                <span>test Notes</span>
                            </div>
                        </div>
                        <Carts view cartArr={cartArr} setCartArr={setCartArr} />
                    </div>
                </div>
            </main>
        </>
    )
}

export default DetailsRequest